import { render, staticRenderFns } from "./viewDashboardList.vue?vue&type=template&id=26a1f510&"
import script from "./viewDashboardList.vue?vue&type=script&lang=js&"
export * from "./viewDashboardList.vue?vue&type=script&lang=js&"
import style0 from "./viewDashboardList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports